module.exports = __webpack_public_path__ + "5367f8394542e3fcbac9e0852e85ffe3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/simple-red.png
// module id = 1938
// module chunks = 0